import classnames from 'classnames';
import React, { forwardRef, Ref } from 'react';

import Button from '../Button';
import { LinkButtonTypes } from '../ButtonTypes';
import { SharedButtonProps } from '../Props';

export type LinkButtonProps = SharedButtonProps<LinkButtonTypes>;

const LinkButton = forwardRef(
    (
        { children, iconOnRightSide = false, buttonType = 'link', icon, ...rest }: SharedButtonProps<LinkButtonTypes>,
        ref: Ref<HTMLButtonElement>,
    ): JSX.Element => (
        <Button
            {...rest}
            buttonType={buttonType}
            ref={ref}
            icon={icon}
            iconOnRightSide={iconOnRightSide}
            className={classnames(rest.className, {
                'button--link__icon-right': iconOnRightSide,
                'icon-right': icon && iconOnRightSide,
            })}
        >
            {children}
        </Button>
    ),
);

export default LinkButton;
